<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full">
                <vx-card id="resellerDiv"  class="vs-con-loading__container">
                    <div class="vx-row">
                        <div class="vx-col xl:w-1/3 w-full">
                            <table class="simple-table mt-6" v-if="!editEnabled">
                                <tr>
                                    <td class="font-semibold">Username:</td>
                                    <td>{{ reseller.username }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Email:</td>
                                    <td>{{ reseller.email }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Clients:</td>
                                    <td>{{ reseller.total_clients }} / {{reseller.client_limit}}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Credits:</td>
                                    <td>{{ reseller.credits }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Default user connections:</td>
                                    <td>{{ reseller.default_user_connections }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Additional connection credits:</td>
                                    <td>{{ reseller.additional_connection_credit }}</td>
                                </tr>
                            </table>
                            <div v-else>
                                <p class="mt-6">Email</p>
                                <vs-input v-model="editObject['email']" class="w-full"></vs-input>
                                <p class="mt-6">Client limit</p>
                                <vs-input v-model="editObject['client_limit']" class="w-full"></vs-input>
                                <p class="mt-6">Default user connections</p>
                                <vs-input v-model="editObject['default_user_connections']" class="w-full"></vs-input>
                                <p class="mt-6">Additional connection credits</p>
                                <vs-input v-model="editObject['additional_connection_credit']" class="w-full"></vs-input>
                            </div>
                        </div>
                        <div class="vx-col xl:w-2/3 w-full">
                            <credit-changes-table ref="creditChangesTable" :reseller-id="$route.params.id"/>
                        </div>
                    </div>
                    <vs-divider/>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-edit" v-if="!editEnabled" color="warning" class="mt-6; mr-1" @click="editEnabled = true">Edit</vs-button>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-lock" v-if="!editEnabled" color="primary" class="mt-6; mr-1" @click="changeResellerPassPrompt = true">Change password</vs-button>
                    <vs-button style="float: right" icon-pack="feather" icon="icon-dollar-sign" v-if="!editEnabled" color="success" class="mt-6; mr-1" @click="addCreditsPrompt = true">Add credits</vs-button>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-save" v-if="editEnabled" color="success" class="mt-6; mr-1" @click="saveReseller">Save</vs-button>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-x" v-if="editEnabled" color="warning" class="mt-6; mr-1" @click="editEnabled = false">Cancel</vs-button>
                    <vs-button style="float: right" icon-pack="feather" icon="icon-trash-2" v-if="editEnabled" color="danger" class="mt-6; mr-1" @click="removeReseller">Remove</vs-button>
                    <div style="clear: both"></div>
                </vx-card>
            </div>
            <div class="vx-col w-full mt-6">
                <reseller-packages :reseller-id="$route.params.id"/>
            </div>
        </div>

        <vs-popup title="Change password" :active.sync="changeResellerPassPrompt">
            <div id="changeResellerPassDiv" class="vs-con-loading__container" >
                <p class="mt-6">Password</p>
                <vs-input type="password" v-model="editObject['password']" class="w-full"></vs-input>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="changeResellerPass">Save</vs-button>
            </div>
        </vs-popup>

        <vs-popup title="Add credits" :active.sync="addCreditsPrompt">
            <div id="addCreditsDiv" class="vs-con-loading__container" >
                <p class="mt-6">Credits</p>
                <vs-input v-model="addCreditsNum" class="w-full"></vs-input>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addCredits">Add</vs-button>
            </div>
        </vs-popup>

    </div>

</template>
<script>

    import ResellerPackages from './ResellerPackages'
    import CreditChangesTable from './CreditChangesTable'

    export default {

        components: {
            CreditChangesTable,
            ResellerPackages
        },
        data() {
            return {

                reseller: {
                    email: '',
                    username: '',
                    default_user_connections: 0,
                    additional_connection_credit: 0
                },

                editObject: {},
                editEnabled: false,
                changeResellerPassPrompt: false,

                addCreditsPrompt: false,
                addCreditsNum: 0

            }
        },
        methods: {

            loadData() {
                this.$vs.loading({
                    container: '#resellerDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/reseller/' + this.$route.params.id)
                loadPromise.then(function(response) {
                    thisIns.reseller = response.data
                    thisIns.editObject = JSON.parse(JSON.stringify(response.data))
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#resellerDiv > .con-vs-loading')
                })
            },
            saveReseller() {
                this.$vs.loading({
                    container: '#resellerDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const savePromise = this.$http.put('/api/management/v1/reseller/' + this.$route.params.id, {
                    email: this.editObject.email,
                    client_limit: Number(this.editObject.client_limit),
                    default_user_connections: Number(this.editObject.default_user_connections),
                    additional_connection_credit: Number(this.editObject.additional_connection_credit)
                })

                savePromise.then(function() {
                    thisIns.$printSuccess('Reseller saved')
                    thisIns.editEnabled = false
                    thisIns.loadData()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#resellerDiv > .con-vs-loading')
                })
            },
            changeResellerPass() {
                this.$vs.loading({
                    container: '#changeResellerPassDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const savePromise = this.$http.put('/api/management/v1/reseller/' + this.$route.params.id + '/password', {
                    password: this.editObject.password
                })

                savePromise.then(function() {
                    thisIns.$printSuccess('Reseller password changed')
                    thisIns.changeResellerPassPrompt = false
                    thisIns.editObject.password = ''
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#changeResellerPassDiv > .con-vs-loading')
                })
            },
            removeReseller() {
                const thisIns = this
                const removePromise = this.$http.delete('/api/management/v1/reseller/' + this.$route.params.id)
                removePromise.then(function() {
                    thisIns.$printSuccess('Reseller removed')
                    thisIns.$nextTick(() => {
                        thisIns.$router.push('/resellers')
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })
            },
            addCredits() {
                this.$vs.loading({
                    container: '#addCreditsDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const savePromise = this.$http.put('/api/management/v1/reseller/' + this.$route.params.id + '/credits', {
                    credits: Number(this.addCreditsNum)
                })

                savePromise.then(function() {
                    thisIns.$printSuccess('Credits added')
                    thisIns.addCreditsPrompt = false
                    thisIns.addCreditsNum = ''
                    thisIns.loadData()
                    thisIns.$refs.creditChangesTable.loadData()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#addCreditsDiv > .con-vs-loading')
                })
            }
        },
        mounted() {
            this.loadData()
        }
    }

</script>
<style lang="scss">
    .simple-table {
        td {
            vertical-align: top;
            min-width: 250px;
            padding-bottom: 1.3rem;
            word-break: break-all;

            @media screen and (max-width:370px) {
                display: block;
            }
        }
    }

</style>
